module.exports = __webpack_public_path__ + "img/forestorytellingtour_main_04.65db8856.jpg";